/* Stickidy ürün sayfası: kurdele/ölçü çipi, 3 Al 2 Öde sayacı, üçlü paket, koleksiyon şeridi "Sepete ekle", tepsiye ekle. */
(function () {
  'use strict';
  if (window.__stkPdp) return; window.__stkPdp = true;
  var cfg = window.StickidyPdp || {};
  var top = document.querySelector('[data-stk-pd="top"]'), mid = document.querySelector('[data-stk-pd="mid"]'), after = document.querySelector('[data-stk-pd="after"]');
  var moneyEl = top || document.querySelector('[data-stk-more]');
  var moneyFmt = (moneyEl && moneyEl.getAttribute('data-money')) || '{{amount}} TL';
  var toastEl = null, toastT = 0;

  function money(c) {
    var n = (c / 100), s;
    if (/amount_with_comma_separator/.test(moneyFmt)) s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (/amount_no_decimals/.test(moneyFmt)) s = String(Math.round(n));
    else s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'stk-pd__toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addItems(items) { return post('/cart/add.js', { items: items }); }
  function currentVid() {
    var i = document.querySelector('product-form form input[name="id"]') || document.querySelector('.product-variant-id');
    return i && i.value ? parseInt(i.value, 10) : (after ? parseInt(after.querySelector('[data-stk-tray]').getAttribute('data-vid'), 10) : 0);
  }

  /* ------------------------------ varsayılan ölçü: 1×1 cm yerine ilk büyük ölçü ------------------------------ */
  // URL'de ?variant= yoksa ve sayfa "1 x 1 CM" seçili açıldıysa, sticker'da bir sonraki satılabilir ölçüye (genelde 4 cm) geç.
  // 1 cm seçeneği listede kalır; müşteri isterse yine seçer. Kaplama/kartlık gibi ürünler etkilenmez (değer 1×1 cm değil).
  (function () {
    if (/[?&]variant=/.test(location.search)) return;
    var ONE = /^\s*1\s*[x×]\s*1\s*cm\s*$/i;
    var radios = [].slice.call(document.querySelectorAll('variant-radios input[type="radio"]'));
    var cur = radios.filter(function (r) { return r.checked && ONE.test(r.value); })[0];
    if (cur) {
      var alt = radios.filter(function (r) { return r.name === cur.name && !ONE.test(r.value) && !r.disabled && !r.classList.contains('disabled'); })[0];
      if (alt) { alt.checked = true; alt.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var sel = [].slice.call(document.querySelectorAll('variant-selects select')).filter(function (x) { return ONE.test(x.value); })[0];
    if (sel) {
      var o = [].slice.call(sel.options).filter(function (x) { return !ONE.test(x.value) && !x.disabled; })[0];
      if (o) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  })();

  /* ------------------------------ ölçü ------------------------------ */
  function parseSize(txt) {
    txt = String(txt || '').replace(/\s+/g, ' ');
    var m = txt.match(/(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)\s*cm/);
    if (m) return { v: m[1].replace('.', ',') + ' × ' + m[2].replace('.', ',') + ' cm', h: 'Tek ölçü' };
    m = txt.match(/(\d+(?:[.,]\d+)?)\s*[–-]\s*(\d+(?:[.,]\d+)?)\s*cm/);
    if (m) return { v: '≈ ' + m[1].replace('.', ',') + '–' + m[2].replace('.', ',') + ' cm', h: /uzun kenar/i.test(txt) ? 'Tek ölçü · uzun kenar' : 'Tek ölçü' };
    m = txt.match(/(\d+(?:[.,]\d+)?)\s*cm/);
    if (m) return { v: m[1].replace('.', ',') + ' cm', h: /uzun kenar/i.test(txt) ? 'Tek ölçü · uzun kenar' : 'Tek ölçü' };
    return null;
  }
  var size = null;
  if (mid && mid.getAttribute('data-single') === '1') {
    size = parseSize(mid.getAttribute('data-desc'));
    var row = mid.querySelector('[data-stk-size]');
    if (size && row) { row.querySelector('[data-stk-size-v]').textContent = size.v; row.querySelector('[data-stk-size-h]').textContent = size.h; row.hidden = false; }
  }

  /* ------------------------------ galeri: kurdele + çip ------------------------------ */
  (function () {
    var g = document.querySelector('media-gallery slider-component') || document.querySelector('media-gallery .content-item-container');
    if (!g) return;
    if (cfg.ribbon !== false && cfg.coll && cfg.coll.title) { var r = document.createElement('span'), ri = document.createElement('span'); r.className = 'stk-pd__rib'; ri.textContent = cfg.coll.title; r.appendChild(ri); g.appendChild(r); }
    var chipTxt = size ? size.v : (cfg.chip || '');
    if (chipTxt) { var c = document.createElement('span'); c.className = 'stk-pd__chip'; c.textContent = chipTxt; g.appendChild(c); }
  })();

  /* ------------------------------ kaplama: model açılır listesi ------------------------------ */
  (function () {
    var md = mid ? mid.querySelector('[data-stk-model]') : null; if (!md) return;
    var cat = md.getAttribute('data-cat'), optName = md.getAttribute('data-opt');
    var btn = md.querySelector('[data-md-btn]'), panel = md.querySelector('[data-md-panel]'), list = md.querySelector('[data-md-list]'), q = md.querySelector('[data-md-q]'), link = md.querySelector('[data-md-link]');
    var nameEl = md.querySelector('[data-md-name]'), subEl = md.querySelector('[data-md-sub]'), btnCv = md.querySelector('[data-md-cv]');
    var rows = [].slice.call(list.querySelectorAll('[data-md-row]'));
    var radios = [].slice.call(document.querySelectorAll('input[type="radio"][name="' + optName.replace(/"/g, '\\"') + '"]'));
    var fs = radios.length ? (radios[0].closest('fieldset') || radios[0].closest('.product-form__input') || radios[0].parentNode.parentNode) : null;
    if (fs) fs.classList.add('stk-md-hide');
    // Tema varyant değişince radyoları yeniden çiziyor (eski düğümler DOM'dan kopuyor) → her seçimde güncel radyoları bul (28 Eyl 2026 düzeltme:
    // ikinci model seçiminde etiket değişip sepetteki varyant ilk seçimde kalıyordu).
    function curRadios() { return [].slice.call(document.querySelectorAll('input[type="radio"][name="' + optName.replace(/"/g, '\\"') + '"]')); }
    var back = document.createElement('div'); back.className = 'stk-md__backdrop'; md.appendChild(back);
    function seriesOf(key) {
      var m;
      if (cat === 'iphone') { if (/air/.test(key)) return 'iPhone 17'; if (/duo/.test(key)) return 'iPhone 18'; m = /iphone (\d+)/.exec(key); return m ? 'iPhone ' + m[1] : 'iPhone'; }
      if (cat === 'samsung') { if (/z (fold|flip)/.test(key)) return 'Galaxy Z'; m = /galaxy ([sa])(\d+)/.exec(key); if (!m) return 'Galaxy'; return m[1] === 's' ? 'Galaxy S' + m[2] : 'Galaxy A'; }
      if (cat === 'ipad') { if (/mini/.test(key)) return 'iPad mini'; if (/pro/.test(key)) return 'iPad Pro'; if (/air/.test(key)) return 'iPad Air'; return 'iPad'; } // mini önce: 'mini 7 (a17 pro)'
      if (cat === 'macbook') { if (/^mac (studio|mini)/.test(key)) return 'Mac'; if (/pro/.test(key)) return 'MacBook Pro'; if (/air/.test(key)) return 'MacBook Air'; return 'MacBook'; }
      return '';
    }
    // seri başlıkları: satırlar seriye göre gruplanır (ilk görülme sırası korunur), her grubun başına başlık
    var groups = [], byG = {};
    rows.forEach(function (r) { var g = seriesOf(r.getAttribute('data-v').toLowerCase()); r.setAttribute('data-g', g); if (!byG[g]) { byG[g] = []; groups.push(g); } byG[g].push(r); });
    groups.forEach(function (g) {
      if (g) { var h = document.createElement('span'); h.className = 'stk-md__gh'; h.textContent = g; h.setAttribute('data-md-gh', g); list.appendChild(h); }
      byG[g].forEach(function (r) { list.appendChild(r); });
    });
    var empty = document.createElement('div'); empty.className = 'stk-md__empty'; empty.textContent = 'Model bulunamadı'; empty.hidden = true; list.appendChild(empty);
    function draw(cv, v) {
      var ST = window.StickidyStudio; if (!ST || !ST.renderDevice || cv.__done) return;
      var key = String(v).toLowerCase();
      if (!(ST.DEVICES[cat] || {})[key]) { cv.style.visibility = 'hidden'; cv.__done = true; return; }
      try { ST.renderDevice(cv, cat, key, 0, { pad: 2, shadowScale: 0.5 }); cv.__done = true; } catch (e) { cv.style.visibility = 'hidden'; }
    }
    function drawAll() { rows.forEach(function (r) { draw(r.querySelector('[data-md-rcv]'), r.getAttribute('data-v')); }); }
    function drawBtn() { btnCv.__done = false; btnCv.style.visibility = ''; var ctx = btnCv.getContext && btnCv.getContext('2d'); if (ctx) ctx.clearRect(0, 0, btnCv.width, btnCv.height); draw(btnCv, nameEl.textContent); }
    function whenStudio(fn) { if (window.StickidyStudio && window.StickidyStudio.renderDevice) fn(); else { var k = 0, iv = setInterval(function () { if (window.StickidyStudio && window.StickidyStudio.renderDevice) { clearInterval(iv); fn(); } else if (++k > 60) clearInterval(iv); }, 150); } }
    function paintSel(v) {
      nameEl.textContent = v;
      var r = rows.filter(function (x) { return x.getAttribute('data-v') === v; })[0];
      rows.forEach(function (x) { x.classList.toggle('is-on', x === r); });
      var n = r ? parseInt(r.getAttribute('data-n'), 10) || 0 : 0, av = r ? r.getAttribute('data-av') === 'true' : true;
      subEl.textContent = (n ? n + ' tasarım' : '') + (n ? ' · ' : '') + (av ? 'stokta' : 'tükendi');
      if (r && n && r.getAttribute('data-u')) { link.href = r.getAttribute('data-u'); link.textContent = v + ' için ' + n + ' tasarım ›'; link.hidden = false; } else link.hidden = true;
      whenStudio(drawBtn);
    }
    // Mobilde panel + perde body'ye taşınır (alt sayfa); tema sütunundaki transform'lar fixed konumu bozmasın.
    function open() { md.classList.add('is-open'); if (window.innerWidth <= 749) { document.body.appendChild(back); document.body.appendChild(panel); } back.classList.add('is-on'); panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); whenStudio(drawAll); if (window.innerWidth > 749) setTimeout(function () { q.focus(); }, 30); var on = list.querySelector('.is-on'); if (on && on.scrollIntoView) on.scrollIntoView({ block: 'center' }); }
    function close() { md.classList.remove('is-open'); back.classList.remove('is-on'); panel.hidden = true; if (panel.parentNode !== md) { md.appendChild(panel); md.appendChild(back); } btn.setAttribute('aria-expanded', 'false'); q.value = ''; filter(); }
    function filter() {
      var t = q.value.trim().toLocaleLowerCase('tr').replace(/\s+/g, ' '), n = 0, seen = {};
      rows.forEach(function (r) { var ok = !t || r.getAttribute('data-v').toLocaleLowerCase('tr').indexOf(t) >= 0; r.hidden = !ok; if (ok) { n++; seen[r.getAttribute('data-g')] = 1; } });
      list.querySelectorAll('[data-md-gh]').forEach(function (h) { h.hidden = !seen[h.getAttribute('data-md-gh')]; });
      empty.hidden = n > 0;
    }
    function select(v) {
      var r = curRadios().filter(function (x) { return x.value === v; })[0];
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      paintSel(v); close(); confirm(v);
    }
    btn.addEventListener('click', function () { md.classList.contains('is-open') ? close() : open(); });
    back.addEventListener('click', close);
    md.querySelector('[data-md-close]').addEventListener('click', close);
    q.addEventListener('input', filter);
    q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { var f = rows.filter(function (r) { return !r.hidden && r.getAttribute('data-av') === 'true'; })[0]; if (f) select(f.getAttribute('data-v')); } if (e.key === 'Escape') close(); });
    list.addEventListener('click', function (e) { var r = e.target.closest('[data-md-row]'); if (!r || r.getAttribute('data-av') !== 'true') return; select(r.getAttribute('data-v')); });
    document.addEventListener('click', function (e) { if (md.classList.contains('is-open') && !md.contains(e.target) && !panel.contains(e.target) && e.target !== back) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('change', function (e) { var r = e.target; if (r && r.type === 'radio' && r.name === optName && r.checked && r.value !== nameEl.textContent && confirmed) paintSel(r.value); });
    paintSel(nameEl.textContent);

    /* model onayı: modele özel kesim → müşteri modelini seçmeden sepete ekleyemez.
       Açık başlar: URL'de ?variant= varsa (cihaz koleksiyonundan gelindi) ya da bu cihaz türünde daha önce model seçildiyse (hatırlanır). */
    var MKEY = 'stkModel.v1';
    function memGet() { try { return (JSON.parse(localStorage.getItem(MKEY) || '{}') || {})[cat] || ''; } catch (e) { return ''; } }
    function memSet(v) { try { var o = JSON.parse(localStorage.getItem(MKEY) || '{}') || {}; o[cat] = v; localStorage.setItem(MKEY, JSON.stringify(o)); } catch (e) { /* yoksay */ } }
    var confirmed = rows.length < 2 || /[?&]variant=/.test(location.search);
    if (confirmed && /[?&]variant=/.test(location.search)) memSet(nameEl.textContent);
    if (!confirmed) {
      var mem = memGet(), mr = mem ? rows.filter(function (x) { return x.getAttribute('data-v') === mem && x.getAttribute('data-av') === 'true'; })[0] : null;
      if (mr) {
        confirmed = true;
        if (nameEl.textContent !== mem) { var rr = curRadios().filter(function (x) { return x.value === mem; })[0]; if (rr) { rr.checked = true; rr.dispatchEvent(new Event('change', { bubbles: true })); } paintSel(mem); }
      }
    }
    function confirm(v) { confirmed = true; md.classList.remove('is-need'); memSet(v); }
    if (!confirmed) {
      md.classList.add('is-need');
      nameEl.textContent = 'Modelini seç'; subEl.textContent = 'Sepete eklemeden önce cihaz modelini seç';
      rows.forEach(function (x) { x.classList.remove('is-on'); }); link.hidden = true; btnCv.style.visibility = 'hidden';
    }
    var scope = (fs && fs.closest('.shopify-section')) || document;
    function needModel(e) {
      if (confirmed) return false;
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      toast('Önce cihaz modelini seç'); open();
      try { md.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) { /* yoksay */ }
      return true;
    }
    document.addEventListener('click', function (e) {
      if (confirmed || !e.target.closest) return;
      var hit = e.target.closest('button[name="add"], .shopify-payment-button, shopify-payment-button, [data-stk-badd]');
      if (hit && (scope.contains(hit) || hit.hasAttribute('data-stk-badd'))) needModel(e);
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target; if (confirmed || !f || !f.matches || !f.matches('form[action*="/cart/add"]') || !scope.contains(f)) return;
      needModel(e);
    }, true);
  })();

  /* ------------------------------ uygulama videosu ------------------------------ */
  (function () {
    var v = document.querySelector('[data-stk-vid]'); if (!v) return;
    var play = v.querySelector('[data-stk-play]'), tpl = v.querySelector('template[data-stk-vsrc]');
    function start() { if (!tpl || v.classList.contains('is-playing')) return; v.appendChild(tpl.content.cloneNode(true)); v.classList.add('is-playing'); }
    play.addEventListener('click', start);
    var l = document.querySelector('[data-stk-video-link]'); if (l) l.addEventListener('click', function () { setTimeout(start, 400); });
  })();

  /* ------------------------------ 3 Al 2 Öde sayacı ------------------------------ */
  var deal = mid ? mid.querySelector('[data-stk-deal]') : null;
  var dealTypes = deal ? deal.getAttribute('data-types').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean) : [];
  var buy = deal ? (parseInt(deal.getAttribute('data-buy'), 10) || 3) : 3;
  function paintDeal(cart) {
    if (!deal) return;
    var tot = 0;
    (cart && cart.items || []).forEach(function (c) {
      var ty = String(c.product_type || '').toLowerCase(); if (!ty) ty = 'stickers';
      if (dealTypes.indexOf(ty) >= 0) tot += c.quantity;
    });
    var free = Math.floor(tot / buy), rem = tot % buy, need = rem === 0 ? (tot === 0 ? buy : 0) : buy - rem;
    var bar = deal.querySelector('[data-stk-bar]'), t = deal.querySelector('[data-stk-deal-t]');
    bar.querySelectorAll('i').forEach(function (i, k) { i.classList.toggle('is-on', k < (rem === 0 && free > 0 ? buy : rem)); });
    deal.classList.toggle('is-done', rem === 0 && free > 0);
    if (tot === 0) t.innerHTML = cfg.kind === 'cover' ? 'Kaplama + 2 sticker → <b>en ucuzu bedava</b>' : buy + ' sticker seç, <b>en ucuzu bedava</b>';
    else if (rem === 0) t.innerHTML = '3 Al 2 Öde aktif: <b>' + free + ' sticker bedava</b> 🎉';
    else t.innerHTML = 'Sepette ' + tot + ' var, <b>' + need + ' tane daha ekle</b> biri bedava' + (free > 0 ? ' · ' + free + ' bedava' : '');
  }
  function refreshDeal() { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(paintDeal).catch(function () { /* yoksay */ }); }
  refreshDeal();
  (function () {
    var of = window.fetch;
    window.fetch = function (input, init) {
      var p = of.call(this, input, init);
      try { var u = String(input && input.url ? input.url : input); if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshDeal, 250); }, function () { /* yoksay */ }); } catch (e) { /* yoksay */ }
      return p;
    };
  })();

  /* ------------------------------ üçlü paket ------------------------------ */
  (function () {
    var b = after ? after.querySelector('[data-stk-bundle]') : null; if (!b) return;
    var cur, sibs; try { cur = JSON.parse(b.getAttribute('data-cur')); sibs = JSON.parse(b.getAttribute('data-sibs')); } catch (e) { return; }
    if (!sibs || sibs.length < 2) { b.hidden = true; return; }
    var off = 0, items = b.querySelector('[data-stk-bitems]'), oldEl = b.querySelector('[data-stk-bold]'), newEl = b.querySelector('[data-stk-bnew]');
    // Kaplamada: seçili varyantın adı (model / model + yüzey) → kardeş üründe aynı adlı varyant; yoksa ilk satılabilir varyant.
    function curV() { var id = currentVid(), e = cur.vt ? cur.vt[String(id)] : null; return e ? { t: e[0], p: e[1] } : { t: null, p: cur.p }; }
    function pick(p) { var t = curV().t, m = p.vs && t ? p.vs[t] : null; return m ? { id: m[0], p: m[1] } : { id: p.id, p: p.p }; }
    function pair() { return [sibs[off % sibs.length], sibs[(off + 1) % sibs.length]]; }
    function card(p, cls, sub, badge) { return '<span class="stk-pd__bi' + (cls ? ' ' + cls : '') + '"><img src="' + esc(p.img) + '" alt=""><b>' + esc(p.t) + '</b><i>' + esc(sub) + '</i>' + (badge ? '<em>' + badge + '</em>' : '') + '</span>'; }
    function paint() {
      var pr = pair(), all = [{ t: cur.t, img: cur.img, p: curV().p }, pr[0], pr[1]].map(function (p, k) { return k ? { t: p.t, img: p.img, p: pick(p).p } : p; }), sum = 0, min = Infinity;
      all.forEach(function (p) { sum += p.p; if (p.p < min) min = p.p; });
      var cheapest = all.filter(function (p) { return p.p === min; }).pop();
      items.innerHTML = all.map(function (p, k) { return (k ? '<span class="stk-pd__plus">+</span>' : '') + card(p, k === 0 ? 'is-cur' : '', k === 0 ? 'bu ürün' : money(p.p), p === cheapest ? 'bedava' : ''); }).join('');
      oldEl.textContent = money(sum); newEl.textContent = money(sum - min);
    }
    paint();
    // Tema varyant değişiminde gizli id alanını fetch sonrası günceller; birkaç kez yeniden çiz.
    document.addEventListener('change', function (e) { if (cur.vt && e.target && e.target.matches && e.target.matches('input[type="radio"]')) [80, 500, 1500].forEach(function (ms) { setTimeout(paint, ms); }); });
    b.querySelector('[data-stk-bswap]').addEventListener('click', function () { off = (off + 2) % sibs.length; paint(); });
    b.querySelector('[data-stk-badd]').addEventListener('click', function () {
      var btn = this, pr = pair(), vid = currentVid() || cur.id; btn.disabled = true;
      addItems([{ id: vid, quantity: 1 }, { id: pick(pr[0]).id, quantity: 1 }, { id: pick(pr[1]).id, quantity: 1 }])
        .then(function () { toast('Üçü sepete eklendi 🎉'); refreshDeal(); setTimeout(function () { window.location.href = '/cart'; }, 500); })
        .catch(function (e) { btn.disabled = false; toast(esc((e && (e.description || e.message)) || 'Eklenemedi, tekrar dene')); });
    });
  })();

  /* ------------------------------ koleksiyon şeridi: sepete ekle ------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-stk-add]'); if (!btn) return;
    var id = parseInt(btn.getAttribute('data-stk-add'), 10); if (!id) return;
    btn.disabled = true;
    addItems([{ id: id, quantity: 1 }]).then(function () {
      btn.disabled = false; btn.classList.add('is-ok'); var old = btn.textContent; btn.textContent = 'Eklendi ✓';
      setTimeout(function () { btn.classList.remove('is-ok'); btn.textContent = old; }, 1800);
      toast(esc(btn.getAttribute('data-title')) + ' sepete eklendi<a href="/cart">Sepete git ›</a>'); refreshDeal();
    }).catch(function (err) { btn.disabled = false; toast(esc((err && (err.description || err.message)) || 'Eklenemedi')); });
  });

  /* ------------------------------ Hızlı Seçim tepsisine ekle (localStorage: stkPick.v1) ------------------------------ */
  (function () {
    var btn = after ? after.querySelector('[data-stk-tray]') : null; if (!btn) return;
    var KEY = 'stkPick.v1', TTL = 7 * 24 * 3600 * 1000;
    function cmOf(title, one) { var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*cm/i); return m ? parseFloat(m[1].replace(',', '.')) : one; }
    btn.addEventListener('click', function () {
      var p; try { p = JSON.parse(btn.getAttribute('data-json')); } catch (e) { return; }
      var vid = currentVid() || parseInt(btn.getAttribute('data-vid'), 10);
      var v = (p.v || []).filter(function (x) { return x.id === vid; })[0] || p.v[0]; if (!v) return;
      var one = /dollar|pantone/.test(p.h) ? 15 : 6, cm = size && /^\d/.test(size.v) && !/×/.test(size.v) ? parseFloat(size.v) : cmOf(v.t, one);
      var d; try { d = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { d = null; }
      if (!d || !d.ts || Date.now() - d.ts > TTL) d = { items: [], cm: 4, open: false, url: '' };
      d.items = (d.items || []).filter(function (it) { return it && it.vid && it.qty > 0; });
      var it = d.items.filter(function (x) { return x.vid === v.id; })[0];
      if (it) it.qty += 1; else d.items.push({ vid: v.id, pid: p.id, h: p.h, t: p.t, u: p.u, img: p.img, cm: cm, p: v.p, qty: 1, type: p.type || 'Stickers' });
      d.ts = Date.now(); d.open = true; if (!d.url) d.url = btn.getAttribute('data-coll-url');
      try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* yoksay */ }
      var n = d.items.reduce(function (s, x) { return s + x.qty; }, 0);
      btn.classList.add('is-ok'); btn.textContent = 'Tepside ' + n + ' sticker ✓';
      try { document.dispatchEvent(new CustomEvent('stk:pick:sync')); } catch (e) { /* yoksay */ }
      toast('Tepsiye eklendi<a href="' + esc(btn.getAttribute('data-coll-url')) + '">Koleksiyonda devam et ›</a>');
    });
  })();

  /* ------------------------------ Mini Stüdyo (sticker: cihaz çizimi + gerçek oranlı sticker, sürükle/döndür) ------------------------------ */
  (function () {
    if (cfg.kind !== 'sticker' || !after) return;
    var box = after.querySelector('[data-stk-mini]'); if (!box) return;
    // Ölçü: "6 × 7 cm" → uzun kenar 7; "≈ 5–7 cm" aralığı → orta değer (Stüdyo varsayılanı 6); "15 cm" → 15; yoksa dollar/pantone 15, diğer 6
    var nums = size ? (size.v.match(/\d+(?:,\d+)?/g) || []).map(function (x) { return parseFloat(x.replace(',', '.')); }) : [];
    var cm = !nums.length ? (/dollar|pantone/.test(box.getAttribute('data-h')) ? 15 : 6) : (/[–-]/.test(size.v) && nums.length >= 2 ? (nums[0] + nums[1]) / 2 : Math.max.apply(null, nums));
    if (!(cm > 0) || cm > 12) return;
    box.hidden = false;
    box.querySelector('[data-stk-mini-sub]').textContent = '≈ ' + String(cm).replace('.', ',') + ' cm · gerçek oran · sürükle, döndür';
    // Masaüstünde galerinin (sticky media-gallery) içine, en alta taşı; dar ekranda yerinde kalsın
    var mark = document.createComment('stk-mini'); box.parentNode.insertBefore(mark, box);
    var mq = window.matchMedia('(min-width:990px)');
    function place() {
      var mg = document.querySelector('media-gallery');
      if (mq.matches && mg) { if (box.parentNode !== mg) mg.appendChild(box); }
      else if (mark.parentNode && box.previousSibling !== mark) mark.parentNode.insertBefore(box, mark.nextSibling);
      if (ready) fit();
    }
    place(); if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
    var CATS = [['iphone', 'iPhone', 'iphone 17 pro'], ['samsung', 'Samsung', 'galaxy s25'], ['ipad', 'iPad', 'ipad air 11 (m3) 2025'], ['macbook', 'MacBook', 'macbook pro 14 m5'], ['stanley', 'Stanley', 'quencher h2.0 flowstate 1.18 l']];
    var chips = box.querySelector('[data-stk-mini-chips]'), stage = box.querySelector('[data-stk-mini-stage]'), cv = box.querySelector('[data-stk-mini-cv]'), st = box.querySelector('[data-stk-mini-st]'), rotB = box.querySelector('[data-stk-mini-rot]'), hint = box.querySelector('[data-stk-mini-hint]'), go = box.querySelector('[data-stk-mini-go]');
    var cat = 'iphone', key = '', ready = false, cut = null, ppm = 1, S = { x: 0, y: 0, rot: -0.14 }, ST = null, moved = false;
    CATS.forEach(function (c, i) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = c[1]; b.className = i ? '' : 'is-on'; b.setAttribute('data-cat', c[0]);
      b.addEventListener('click', function () { cat = c[0]; chips.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); }); moved = false; render(); });
      chips.appendChild(b);
    });
    function loadStudio(cb) {
      if (window.StickidyStudio && window.StickidyStudio.renderDevice) { cb(); return; }
      if (!document.querySelector('script[data-stk-studio-src]')) { var sc = document.createElement('script'); sc.src = box.getAttribute('data-js'); sc.defer = true; sc.setAttribute('data-stk-studio-src', '1'); document.head.appendChild(sc); }
      var k = 0, iv = setInterval(function () { if (window.StickidyStudio && window.StickidyStudio.renderDevice) { clearInterval(iv); cb(); } else if (++k > 100) clearInterval(iv); }, 100);
    }
    function pickKey(c) { var d = (ST.DEVICES || {})[c[0]] || {}; return d[c[2]] ? c[2] : Object.keys(d)[0]; }
    function render() {
      if (!ST) return;
      var c = CATS.filter(function (x) { return x[0] === cat; })[0]; key = pickKey(c);
      go.href = '/pages/sticker-studio?sticker=' + encodeURIComponent(box.getAttribute('data-h')) + '&cihaz=' + cat;
      var r = ST.renderDevice(cv, cat, key, 0, { pad: 8, shadowScale: 0.6 }); if (!r) return; ppm = r.ppm;
      fit();
    }
    function fit() {
      if (!cut) return;
      // uzun kenar = cm (dik stickerda yükseklik)
      var lng = cm * 10 * ppm, w = cut.width >= cut.height ? lng : lng * cut.width / cut.height, h = w * cut.height / cut.width; st.style.width = w + 'px';
      if (!moved) { S.x = (stage.clientWidth - w) / 2; S.y = (stage.clientHeight - h) / 2 + (cat === 'iphone' || cat === 'samsung' ? stage.clientHeight * 0.08 : 0); }
      st.style.left = S.x + 'px'; st.style.top = S.y + 'px'; st.style.transform = 'rotate(' + S.rot + 'rad)'; st.hidden = false;
    }
    function start() {
      ST = window.StickidyStudio;
      var img = new Image(); img.crossOrigin = 'anonymous'; img.decoding = 'async';
      img.onload = function () {
        var c = ST.cutoutCanvas ? ST.cutoutCanvas(img, 800) : null; if (!c) { box.hidden = true; return; }
        cut = c; c.style.width = '100%'; st.insertBefore(c, rotB); ready = true; render();
      };
      img.onerror = function () { box.hidden = true; };
      img.src = box.getAttribute('data-img');
    }
    // Görünüme yaklaşınca yükle (studio.js ~40 KB gzip)
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); loadStudio(start); } }, { rootMargin: '400px' }) : null;
    if (io) io.observe(box); else loadStudio(start);
    // sürükle
    var drag = null;
    st.addEventListener('pointerdown', function (e) { if (e.target === rotB) return; drag = { x: e.clientX - S.x, y: e.clientY - S.y }; st.classList.add('is-drag'); st.setPointerCapture(e.pointerId); e.preventDefault(); });
    st.addEventListener('pointermove', function (e) { if (!drag) return; S.x = e.clientX - drag.x; S.y = e.clientY - drag.y; moved = true; st.style.left = S.x + 'px'; st.style.top = S.y + 'px'; hint.classList.add('is-off'); });
    st.addEventListener('pointerup', function () { drag = null; st.classList.remove('is-drag'); });
    st.addEventListener('pointercancel', function () { drag = null; st.classList.remove('is-drag'); });
    // döndür
    var rot = null;
    function center() { var r = st.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    rotB.addEventListener('pointerdown', function (e) { var c = center(); rot = { a0: Math.atan2(e.clientY - c.y, e.clientX - c.x), r0: S.rot, c: c }; rotB.setPointerCapture(e.pointerId); e.preventDefault(); e.stopPropagation(); });
    rotB.addEventListener('pointermove', function (e) { if (!rot) return; S.rot = rot.r0 + Math.atan2(e.clientY - rot.c.y, e.clientX - rot.c.x) - rot.a0; moved = true; st.style.transform = 'rotate(' + S.rot + 'rad)'; hint.classList.add('is-off'); });
    rotB.addEventListener('pointerup', function () { rot = null; });
    rotB.addEventListener('pointercancel', function () { rot = null; });
    var rs; window.addEventListener('resize', function () { clearTimeout(rs); rs = setTimeout(function () { if (ready) { moved = false; render(); } }, 150); });
  })();

  /* ------------------------------ sayaç (TR saatine göre günlük dilimler) ------------------------------ */
  (function () {
    var w = mid ? mid.querySelector('[data-stk-timer]') : null; if (!w) return;
    var D = [
      [0, '🌙 GECE FIRSATI', '3 Al 2 Öde · en ucuzu bedava, sepette otomatik'],
      [2, '⏳ 3 AL 2 ÖDE SÜRÜYOR', '3 kaplama ya da sticker seç, en ucuzu bedava'],
      [4, '🌜 GECE FIRSATI SÜRÜYOR', '3 Al 2 Öde — Uyumadan Yakala!'],
      [6, '☕ GÜNE FIRSATLA BAŞLA', '3 Al 2 Öde · sepette otomatik uygulanır'],
      [8, '🔥 HERKES SEPETİNİ DOLDURUYOR', '3 Al 2 Öde — Geç Kalma!'],
      [11, '⚡ 3 AL 2 ÖDE ŞİMDİ AKTİF', '3 seç, en ucuzu bedava'],
      [14, '🚨 ÜÇÜNCÜSÜ BEDAVA', '3 Al 2 Öde — sepette otomatik'],
      [17, '⏰ SAYILI SAATLER KALDI', '3 Al 2 Öde · en ucuzu bedava'],
      [20, '🌆 AKŞAM FIRSATI', '3 Al 2 Öde — kombinini tamamla'],
      [22, '🌙 SON 2 SAAT', '3 Al 2 Öde — Gün Bitmeden Kap!']
    ];
    var hh = w.querySelector('[data-tm-hh]'), mm = w.querySelector('[data-tm-mm]'), ss = w.querySelector('[data-tm-ss]'), bar = w.querySelector('[data-tm-bar]'), eh = w.querySelector('[data-tm-h]'), es = w.querySelector('[data-tm-s]'), last = -1;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function trNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 180) * 60000); }
    function win() {
      var tr = trNow(), now = Date.now(), list = [];
      function at(df, h) { var d = new Date(tr.getTime()); d.setDate(d.getDate() + df); d.setHours(h, 0, 0, 0); return d.getTime() - (new Date().getTimezoneOffset() + 180) * 60000; }
      for (var df = -1; df <= 1; df++) for (var i = 0; i < D.length; i++) list.push({ t: at(df, D[i][0]), i: i });
      list.sort(function (a, b) { return a.t - b.t; });
      for (var j = 1; j < list.length; j++) if (list[j].t > now) return { a: list[j - 1].t, b: list[j].t, i: list[j - 1].i };
      return { a: now, b: now + 3600000, i: 0 };
    }
    function tick() {
      var p = win(), left = p.b - Date.now(), tot = p.b - p.a, sn = Math.max(0, Math.floor(left / 1000)), pct = tot > 0 ? Math.min(100, Math.max(0, (1 - left / tot) * 100)) : 0;
      hh.textContent = pad(Math.floor(sn / 3600)); mm.textContent = pad(Math.floor((sn % 3600) / 60)); ss.textContent = pad(sn % 60);
      if (bar) bar.style.width = pct.toFixed(2) + '%';
      if (p.i !== last) { last = p.i; eh.textContent = D[p.i][1]; es.textContent = D[p.i][2]; }
    }
    if (bar) { bar.style.transition = 'none'; tick(); setTimeout(function () { bar.style.transition = 'width 1s linear'; }, 50); }
    setInterval(tick, 1000);
  })();

  /* ------------------------------ Judge.me: widget gelirse yedek kutuyu gizle ------------------------------ */
  (function () {
    var fb = document.querySelector('[data-stk-revfb]'); if (!fb) return;
    var rb = fb.querySelector('[data-stk-revbtn]');
    function check() {
      var w = document.querySelector('.jdgm-rev-widg');
      if (w && getComputedStyle(w).display !== 'none') { fb.classList.add('is-hidden'); return true; }
      return false;
    }
    if (!check()) { var k = 0, iv = setInterval(function () { if (check() || ++k > 20) clearInterval(iv); }, 500); }
    if (rb && rb.getAttribute('href') === '#stk-reviews') rb.addEventListener('click', function (e) {
      var l = document.querySelector('.jdgm-write-rev-link'); if (l) { e.preventDefault(); l.click(); }
    });
  })();
})();
